// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 10C4 6.13401 7.13401 3 11 3C14.1873 3 16.8756 5.12935 17.7225 8.04306C20.6955 8.39988 23 10.9308 23 14C23 17.3137 20.3137 20 17 20H6C3.23858 20 1 17.7614 1 15C1 12.9443 2.23985 11.18 4.01191 10.4112C4.004 10.275 4 10.1379 4 10Z"}}]};

const CloudFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'cloud-filled',
    ref,
    icon: element,
  },
));

CloudFilledIcon.displayName = 'CloudFilledIcon';

export default CloudFilledIcon;
